import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;
const getAuthToken = () => Cookies.get('access_token');

// Fungsi Header yang Fleksibel
const getAuthHeaders = (data) => {
  const headers = {
    'Authorization': `Bearer ${getAuthToken()}`,
  };

  // Jika data bukan FormData, pakai application/json
  // Jika data adalah FormData, biarkan kosong agar Axios & Browser 
  // mengatur boundary multipart secara otomatis
  if (!(data instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
};

const USER_ENDPOINT = "/master-users"; 

export const rejectMasterUser = async (id, payload) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${USER_ENDPOINT}/reject/${id}`, payload, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error rejecting Master User:", error);
    throw error;
  }
};

export const rejectPelunasanDp = async (id, payload) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${USER_ENDPOINT}/reject-pelunasan/${id}`, payload, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error rejecting Master User:", error);
    throw error;
  }
};


export const rejectPencairan = async (id, payload) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${USER_ENDPOINT}/reject-pencairan/${id}`, payload, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error rejecting Master User:", error);
    throw error;
  }
};
export const fetchMasterUsers = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams(params);
    const response = await axios.get(`${BASE_URL_BE}${USER_ENDPOINT}`, {
      params: urlParams,
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) { throw error; }
};

export const createMasterUser = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}${USER_ENDPOINT}`, formData, {
      headers: getAuthHeaders(formData)
    });
    return response.data;
  } catch (error) { throw error; }
};

export const updateMasterUser = async (id_user, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${USER_ENDPOINT}/${id_user}`, formData, {
      headers: getAuthHeaders(formData)
    });
    return response.data;
  } catch (error) { throw error; }
};

export const updateRO = async (id_user, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${USER_ENDPOINT}/ro/${id_user}`, formData, {
      headers: getAuthHeaders(formData)
    });
    return response.data;
  } catch (error) { throw error; }
};

// --- DELETE MASTER USER ---
export const deleteMasterUser = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}${USER_ENDPOINT}/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting Master User:", error);
    throw error;
  }
};

// --- GET MASTER USER BY ID ---
export const getMasterUserByID = async (id) => {
    try {
      const response = await axios.get(`${BASE_URL_BE}${USER_ENDPOINT}/${id}`, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching Master User detail:", error);
      throw error;
    }
  };

  // --- GET HISTORY PROGRES BY ID KPR ---
export const fetchHistoryKPR = async (id_kpr) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/history`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching KPR History:", error);
    throw error;
  }
};

// --- RIWAYAT PEMBAYARAN DP (CICILAN) ---
export const fetchDpPayments = async (id_kpr) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/dp-payments`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching DP payments:", error);
    throw error;
  }
};

export const createDpPayment = async (id_kpr, formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/dp-payments`, formData, {
      headers: getAuthHeaders(formData)
    });
    return response.data;
  } catch (error) {
    console.error("Error creating DP payment:", error);
    throw error;
  }
};

// --- PENGAKUAN HUTANG USER (sisa DP) ---
export const setPengakuanHutang = async (id_kpr, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/pengakuan-hutang`, formData, {
      headers: getAuthHeaders(formData)
    });
    return response.data;
  } catch (error) {
    console.error("Error saving pengakuan hutang:", error);
    throw error;
  }
};

// --- PENGAJUAN PEMBAYARAN HUTANG USER (HEAD MARKETING) ---
export const createHutangPengajuan = async (id_kpr, formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/hutang-pengajuan`,
      formData,
      { headers: getAuthHeaders(formData) }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating hutang pengajuan:", error);
    throw error;
  }
};

// --- PENETAPAN HUTANG USER (RO) ---
export const setPenetapanHutang = async (id_kpr, payload) => {
  try {
    const response = await axios.put(
      `${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/penetapan-hutang`,
      payload,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error setting hutang user:", error);
    throw error;
  }
};

// --- VALIDASI CICILAN DP (KEUANGAN) ---
export const getPendingDpPayments = async (params = {}) => {
  try {
    const urlParams = new URLSearchParams();
    ['search', 'id_lokasi', 'status'].forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        urlParams.append(key, params[key]);
      }
    });
    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/dp-payments/pending?${urlParams.toString()}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pending DP payments:", error);
    throw error;
  }
};

export const validateDpPayment = async (id_kpr, id_payment, payload) => {
  try {
    const response = await axios.put(
      `${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/dp-payments/${id_payment}/validate`,
      payload,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error validating DP payment:", error);
    throw error;
  }
};

export const rejectDpPayment = async (id_kpr, id_payment, payload) => {
  try {
    const response = await axios.put(
      `${BASE_URL_BE}${USER_ENDPOINT}/${id_kpr}/dp-payments/${id_payment}/reject`,
      payload,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error rejecting DP payment:", error);
    throw error;
  }
};

// --- LAPORAN HUTANG USER ---
export const getLaporanHutangUser = async (filter = {}) => {
  try {
    const urlParams = new URLSearchParams();

    ['id_lokasi', 'id_mo', 'id_ro', 'status', 'mode', 'search', 'tgl_mulai', 'tgl_akhir'].forEach((key) => {
      if (filter[key] !== undefined && filter[key] !== null && filter[key] !== '') {
        urlParams.append(key, filter[key]);
      }
    });

    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/laporan-hutang-user?${urlParams.toString()}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching laporan hutang user:", error);
    throw error;
  }
};

export const getLaporanPenjualanUsers = async (filter = {}) => {
  try {
    const urlParams = new URLSearchParams();

    if (filter.id_bank) urlParams.append('id_bank', filter.id_bank);
    if (filter.id_wilayah) urlParams.append('id_wilayah', filter.id_wilayah);
    if (filter.id_lokasi) urlParams.append('id_lokasi', filter.id_lokasi);
    if (filter.id_marketing) urlParams.append('id_mo', filter.id_marketing);
    if (filter.id_ro) urlParams.append('id_ro', filter.id_ro);
    if (filter.tgl_mulai) urlParams.append('tgl_mulai', filter.tgl_mulai);
    if (filter.tgl_akhir) urlParams.append('tgl_akhir', filter.tgl_akhir);

    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/laporan-penjualan?${urlParams.toString()}`,
      {
        headers: getAuthHeaders()
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Laporan Penjualan:", error);
    throw error;
  }
};
  export const getDetailKPR = async (idKpr) => {
    const response = await axios.get(`${BASE_URL_BE}${USER_ENDPOINT}/detail-penjualan/${idKpr}`, {
        headers: getAuthHeaders()
    });
    return response.data;
};


export const fetchBlokFeeMarketing = async (params = {}) => {
  try {
    if (!params?.id_lokasi) {
      return { data: [] };
    }

    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/akun-fee-marketing`,
      {
        params,
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetch blok fee marketing:", error);
    throw error;
  }
};



export const fetchBiayaAkadNotaris = async (params = {}) => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/akun-akad-notaris`,
      {
        params,
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const fetchBiayaAkadBank = async (params = {}) => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/akun-akad-bank`,
      {
        params,
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchLaporanPenjualanDajam = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams(params);
    const response = await axios.get(`${BASE_URL_BE}${USER_ENDPOINT}/laporan-penjualan-dajam`, {
      params: urlParams,
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) { throw error; }
};

export const fetchMasterUsersDajamPending = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams(params);
    const response = await axios.get(`${BASE_URL_BE}${USER_ENDPOINT}/pengajuan-dajam`, {
      params: urlParams,
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) { throw error; }
};


export const getLaporanAkadKPRUsers = async (filter = {}) => {
  try {
    const urlParams = new URLSearchParams();

    if (filter.id_bank) urlParams.append('id_bank', filter.id_bank);
    if (filter.id_wilayah) urlParams.append('id_wilayah', filter.id_wilayah);
    if (filter.id_lokasi) urlParams.append('id_lokasi', filter.id_lokasi);
    if (filter.id_marketing) urlParams.append('id_mo', filter.id_marketing);
    if (filter.id_ro) urlParams.append('id_ro', filter.id_ro);
    if (filter.tgl_mulai) urlParams.append('tgl_mulai', filter.tgl_mulai);
    if (filter.tgl_akhir) urlParams.append('tgl_akhir', filter.tgl_akhir);

    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/laporan-akad-kpr?${urlParams.toString()}`,
      {
        headers: getAuthHeaders()
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Laporan Penjualan:", error);
    throw error;
  }
};

export const getTotalAjukanKeuangan = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/total-ajukan-keuangan`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching total Ajukan ke Keuangan:", error);
    throw error;
  }
};

export const getTotalPelunasanDP = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/total-pelunasan-dp`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching total Pelunasan DP:", error);
    throw error;
  }
};

export const getTotalPencairanKPR = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/total-pencairan-kpr`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching total Pencairan KPR:", error);
    throw error;
  }
};

export const getDashboardSummary = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/dashboard-summary`,
      {
        headers: getAuthHeaders(),
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Dashboard Summary:", error);
    throw error;
  }
};

export const getRekapKinerjaMarketing = async (filter = {}) => {
  try {
    const urlParams = new URLSearchParams();

    if (filter.id_mo) urlParams.append('id_mo', filter.id_mo);
    if (filter.id_ro) urlParams.append('id_ro', filter.id_ro);

    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/rekap-kinerja-marketing?${urlParams.toString()}`,
      {
        headers: getAuthHeaders()
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Rekap Kinerja Marketing:", error);
    throw error;
  }
};

// --- PENCAPAIAN AKAD MO (GRAFIK DASHBOARD) ---
export const getPencapaianAkadMO = async (filter = {}) => {
  try {
    const urlParams = new URLSearchParams();

    ['tgl_mulai', 'tgl_akhir'].forEach((key) => {
      if (filter[key]) urlParams.append(key, filter[key]);
    });

    const response = await axios.get(
      `${BASE_URL_BE}${USER_ENDPOINT}/pencapaian-akad-mo?${urlParams.toString()}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Pencapaian Akad MO:", error);
    throw error;
  }
};